/**
 * Output-contract markers the LLM agent must wrap its JSON proposal in.
 * See PRD §7.1 and §7.2 — the system prompt instructs the model to use exactly
 * these literals; the backend scans for them to extract the proposal.
 */
export const JSON_OUTPUT_START = '<<<JSON_OUTPUT>>>';
export const JSON_OUTPUT_END = '<<<END_JSON_OUTPUT>>>';
/**
 * Format used to inject a hidden system note into the next LLM turn after a
 * media-upload workflow returns a Drive link (PRD §6.7.2 + §7.7).
 */
export function formatAttachmentSystemNote(input) {
    return `[USER ATTACHED: kind=${input.kind}, filename=${input.filename}, drive_url=${input.driveUrl}]`;
}
//# sourceMappingURL=markers.js.map